import { unstable_createMuiStrictModeTheme as createMuiTheme } from "@mui/material/styles";

// Create a theme instance.
export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#219170',
    },
    secondary: {
      main: '#17664f',
    },
    error: {
      main: '#8B0000',
    },
    background: {
      default: '#fff',
    },
  },
});